/**
 * FeeConfigurationDetailStep.tsx
 * Clean, focused step component for detailed fee configuration
 *
 * Simply uses the error boundary and container components we built.
 * Follows the wizard step pattern: simple component that returns JSX.
 */

import React from 'react';
import { FeeConfigurationErrorBoundary } from './components/FeeConfigurationErrorBoundary';
import { FeeConfigurationContainer } from './components/FeeConfigurationContainer';

/**
 * Fee configuration detail step component
 * Clean step that delegates to specialized components
 */
export const FeeConfigurationDetailStep: React.FC = () => {
  return (
    <FeeConfigurationErrorBoundary>
      <FeeConfigurationContainer />
    </FeeConfigurationErrorBoundary>
  );
};